<template>
  <q-card-section class="column col items-center gap-lg q-pt-xl q-px-xl q-pb-lg">
    <div class="onboarding-icon-badge row items-center justify-center">
      <lucide-icon
        :name="copy.icon"
        size="40px"
        :stroke-width="2"
        aria-hidden="true"
      />
    </div>

    <div class="column items-center gap-xxl text-center">
      <h1 class="text-28 text-font-semibold">
        {{
          copy.headline.replace(
            '{account}',
            accountStore.accountData?.accountName || 'your account'
          )
        }}
      </h1>
      <div
        v-if="copy.subline?.length"
        class="onboarding-subline column items-center gap-xs text-16 text-primary"
      >
        <p
          v-for="(line, index) in copy.subline"
          :key="index"
          class="q-ma-none"
        >
          {{ line }}
        </p>
      </div>
    </div>

    <q-form
      class="column col-grow justify-between gap-lg full-width"
      @submit.prevent="onSubmit"
    >
      <div class="column gap-md">
        <onboarding-name-fields
          v-model:first-name="nameFields.firstName"
          v-model:last-name="nameFields.lastName"
        />
      </div>

      <div class="column items-center gap-xs">
        <q-btn
          flat
          no-caps
          color="secondary"
          class="onboarding-action-btn sm-radius text-14"
          @click="onUseDifferentAccount"
        >
          {{ ONBOARDING_COPY.secondaryActionLabel }}
        </q-btn>
        <q-btn
          type="submit"
          no-caps
          unelevated
          color="brand"
          class="onboarding-action-btn sm-radius text-14 text-font-semibold"
          :disable="!canSubmit"
        >
          {{ copy.ctaLabel }}
          <lucide-icon
            :name="copy.ctaIcon"
            size="18px"
            color="white"
            class="q-ml-xs"
            aria-hidden="true"
          />
        </q-btn>
      </div>
    </q-form>
  </q-card-section>
</template>

<script setup>
  import { computed, reactive } from 'vue'

  import { useAccountStore } from 'src/stores/account'
  import { useOnboardingStore } from 'src/stores/account/onboarding'
  import { useAuthStore } from 'src/stores/auth'

  import { ONBOARDING_COPY, ONBOARDING_FLOW_TYPE } from 'src/services/consts/app.const'
  import { hasLetterOrNumber } from 'src/services/helpers/util.helper'

  import OnboardingNameFields from 'src/components/auth/OnboardingNameFields.vue'

  const accountStore = useAccountStore()
  const onboardingStore = useOnboardingStore()
  const authStore = useAuthStore()

  const copy = ONBOARDING_COPY.inviteeWelcome

  const nameFields = reactive({
    firstName: accountStore.accountData?.firstName ?? '',
    lastName: accountStore.accountData?.lastName ?? '',
  })

  const canSubmit = computed(
    () => hasLetterOrNumber(nameFields.firstName) && hasLetterOrNumber(nameFields.lastName)
  )

  // Signs out to Universal Login — for an invitee who joined with the wrong identity.
  function onUseDifferentAccount() {
    authStore.logout()
  }

  function onSubmit() {
    if (!canSubmit.value) return
    onboardingStore.saveWelcomeAndAdvanceToTerms({
      flowType: ONBOARDING_FLOW_TYPE.INVITEE,
      firstName: nameFields.firstName.trim(),
      lastName: nameFields.lastName.trim(),
    })
  }
</script>
